import { render } from "./Example2.vue?vue&type=template&id=4141ac88"
import script from "./Example2.vue?vue&type=script&lang=ts"
export * from "./Example2.vue?vue&type=script&lang=ts"
script.render = render

export default script